/*************************************************

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/
// https://github.com/backstage/backstage/blob/master/plugins/user-settings/src/components/SettingsPage/SettingsPage.tsx

import {
  SettingsLayout,
  UserSettingsAppearanceCard,
  UserSettingsProfileCard,
} from '@backstage/plugin-user-settings';
import {
  Grid,
} from '@material-ui/core';

// The <UserSettingsGeneral /> component is a convenience wrapper that automatically includes <UserSettingsProfileCard />, <UserSettingsAppearanceCard />, and the <UserSettingsIdentityCard /> that you want to remove.
export const SettingsPage = (
  <SettingsLayout>
    <SettingsLayout.Route path="/general" title="General">
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <UserSettingsProfileCard />
        </Grid>
        <Grid item xs={12} md={6}>
          <UserSettingsAppearanceCard />
        </Grid>
      </Grid>
    </SettingsLayout.Route>
  </SettingsLayout>
);
